import { css } from "lit";

export const style = css`
	* {
		box-sizing: border-box;
	}

	:host {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		position: relative;
	}
	
	.head {
		min-height: 30px;
		flex: 0;
		display: flex;
		gap: 2px;
		padding: 2px;
		flex-direction: row;
		border-bottom: 1px solid var(--og-border-color);
	}

	.head > * {
		flex: 1;
		text-align: center;
	}

	.body {
		flex: 1;
		overflow: hidden;
		display: block;
		width: 100%;
		height: 100%;
		position: relative;
	}

	.body og-tree, .body og-accordion {
		height: 100%;
		border: none;
	}

	.btn-tab {
		width: 40px;
		height: 40px;
	}
`;
